import 'leaflet/dist/leaflet.css'
import { Icon } from 'leaflet'
import React from 'react'
import { MapContainer, Marker, TileLayer } from 'react-leaflet'

import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png'
import markerIcon from 'leaflet/dist/images/marker-icon.png'
import markerShadow from 'leaflet/dist/images/marker-shadow.png'

const defaultIcon = new Icon({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
})

interface LocationMapPreviewProps {
  latitude: number
  longitude: number
}

const LocationMapPreview: React.FC<LocationMapPreviewProps> = ({ latitude, longitude }) => (
  <MapContainer
    center={[latitude, longitude]}
    zoom={13}
    style={{ height: 200, width: '100%', borderRadius: 4 }}
    scrollWheelZoom
    dragging
    touchZoom
    zoomControl
  >
    <TileLayer
      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    />
    <Marker position={[latitude, longitude]} icon={defaultIcon} />
  </MapContainer>
)

export default LocationMapPreview
